<div mat-dialog-title class="matDialogTitle" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
  <div class="loading">
    <div class="my-container" [hidden]="!loading">
      <mat-progress-bar mode="indeterminate" class="detaile"></mat-progress-bar>
    </div>
  </div>

  {{ title }}
  <span class="close" (click)="close()">
    <mat-icon>close</mat-icon>
  </span>
</div>

<div mat-dialog-content class="matDialogContent">
  <div class="content-body control-content-body" [ngClass]="{content_body_en:lang==2}"
    style='overflow-x:auto;direction:rtl;'>
    <mat-table [dataSource]="dataSource" style='min-width:100%'
      class='table-scroll mat_table_fa_without_scroll mat_table_fa_without_scroll_bg not- pe1'
      [ngClass]="{mat_table_en_without_scroll:lang==2,en1:lang == 2}"
      [ngStyle]="{'direction': lang == 2 ? 'ltr' : 'rtl' }">

      <ng-container matColumnDef="row">
        <mat-header-cell *matHeaderCellDef style="max-width:70px">
          #
        </mat-header-cell>
        <mat-cell *matCellDef="let x;let i = index" style="max-width:70px">{{ i+1 }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="title">
        <mat-header-cell *matHeaderCellDef>
          <span *ngIf="lang == 1">عنوان</span>
          <span *ngIf="lang == 2">Title</span>
        </mat-header-cell>
        <mat-cell *matCellDef="let x" (click)="select(x.id,x.title)" class="cursor" style="text-align: center;">
          <div class="right">{{ x.title }}</div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="type_invoice">
        <mat-header-cell *matHeaderCellDef [hidden]="id != 32">
          <span *ngIf="lang == 1">نوع فاکتور</span>
          <span *ngIf="lang == 2">---</span>
        </mat-header-cell>
        <mat-cell *matCellDef="let x" (click)="select(x.id,x.title)" class="cursor" style="text-align: center;"
          [hidden]="id != 32">
          {{ x.type_invoice_title }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="weight">
        <mat-header-cell *matHeaderCellDef [hidden]="id != 171">
          <span *ngIf="lang == 1">نوع فاکتور</span>
          <span *ngIf="lang == 2">---</span>
        </mat-header-cell>
        <mat-cell *matCellDef="let x" (click)="select(x.id,x.title)" class="cursor" style="text-align: center;"
          [hidden]="id != 171">
          {{ x.wharehouse_weight_title }}
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns" color="primary"></mat-header-row>
      <mat-row *matRowDef="let x;let i = index;columns:displayedColumns" (click)="get_bg(x.id)"
        (keyup.enter)="select(x.id,x.title)" [ngClass]="{mat_table_selected:row_id == x.id}"></mat-row>
    </mat-table>
  </div>
</div>